import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { JSX } from "react";
import { UserType } from "../models/base/UserType";
import Loader from "../components/shared/Loader";


interface RequireUserTypeProps {
  allowedRoles: UserType[];
}

export function RequireUserType({ allowedRoles }: RequireUserTypeProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loader fullscreen={true} />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: window.location.pathname }} replace />;
  }

  if (!allowedRoles.includes(user.type)) {
    return <Navigate to="/" state={{ from: window.location.pathname }} replace />;
  }

  return <Outlet />;
}